import { render, staticRenderFns } from "./HeroB2B.vue?vue&type=template&id=81bbbaa6&scoped=true"
import script from "./HeroB2B.vue?vue&type=script&lang=js"
export * from "./HeroB2B.vue?vue&type=script&lang=js"
import style0 from "./HeroB2B.vue?vue&type=style&index=0&id=81bbbaa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bbbaa6",
  null
  
)

export default component.exports